import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.63604 5.64971C7.32387 3.96188 9.61305 3.01367 12 3.01367C14.3869 3.01367 16.6761 3.96188 18.364 5.64971C20.0518 7.33754 21 9.62672 21 12.0137C21 13.1956 20.7672 14.3659 20.3149 15.4578C19.8626 16.5498 19.1997 17.5419 18.364 18.3776C17.5282 19.2134 16.5361 19.8763 15.4442 20.3286C14.3522 20.7809 13.1819 21.0137 12 21.0137C10.8181 21.0137 9.64778 20.7809 8.55585 20.3286C7.46392 19.8763 6.47177 19.2134 5.63604 18.3776C4.80031 17.5419 4.13738 16.5498 3.68508 15.4578C3.23279 14.3659 3 13.1956 3 12.0137C3 9.62672 3.94821 7.33754 5.63604 5.64971ZM8.85 8.86367C9.20147 8.5122 9.77132 8.5122 10.1228 8.86367L12 10.7409L13.8772 8.86367C14.2287 8.5122 14.7985 8.5122 15.15 8.86367C15.5015 9.21514 15.5015 9.78499 15.15 10.1365L13.2728 12.0137L15.15 13.8909C15.5015 14.2424 15.5015 14.8122 15.15 15.1637C14.7985 15.5151 14.2287 15.5151 13.8772 15.1637L12 13.2865L10.1228 15.1637C9.77132 15.5151 9.20147 15.5151 8.85 15.1637C8.49853 14.8122 8.49853 14.2424 8.85 13.8909L10.7272 12.0137L8.85 10.1365C8.49853 9.78499 8.49853 9.21514 8.85 8.86367Z",
  fill: "#C64D51"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}